import React, { Component } from 'react';
import firebase  from 'firebase';

class Disponibilidad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bases:[],
            tipoV:[],
            valueT:undefined,
            valueB:undefined,
            viajes:[],
            baseS:'indice',
            tipoS:'indice'
        }
    }

    cargarData = () =>{
        firebase.database().ref('Bases').once('value').then(snap =>{
            let bases = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                bases.push(datos);
            });
            this.setState({bases})
        });
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap=>{
            let tipoV =[];
            snap.forEach(element => {
                let data = element.val();
                tipoV.push(data);
            });
            this.setState({tipoV})
        })
    }

    componentWillMount(){
        this.cargarData();
        this.getDisponible();
    }

    handleChangeT = (event) =>{
        this.setState({tipoS:event.target.value,baseS:'indice'})
        firebase.database().ref('LaboresEmpresa').orderByChild('tipoV').equalTo(event.target.value).once('value').then(snap =>{
            this.setState({viajes:[]})
            snap.forEach(element => {
                let datos = element.val();
                firebase.database().ref('Empleados/'+datos.emple).once('value').then(snap2 =>{
                    let datos2 = snap2.val();
                    firebase.database().ref('Bases/'+datos.base).once('value').then(snap3 =>{
                        let datos3 = snap3.val();
                        firebase.database().ref('Vehiculos/'+datos2.vehiculo).once('value').then(snap4 =>{
                                let datos4 = snap4.val();
                                datos.emple = datos2.nombre;
                                datos.base = datos3.Nombre;
                                datos.vehiculo = datos4.movil;
                                this.setState({viajes:[...this.state.viajes,datos]});
                        })
                    })
                })
            });
        })
    }
    handleChangeB = (event) =>{
       this.setState({baseS:event.target.value,tipoS:'indice'})
        firebase.database().ref('LaboresEmpresa').orderByChild('base').equalTo(event.target.value).once('value').then(snap =>{
            this.setState({viajes:[]})
            snap.forEach(element => {
                let datos = element.val();
                firebase.database().ref('Empleados/'+datos.emple).once('value').then(snap2 =>{
                    let datos2 = snap2.val();
                    firebase.database().ref('Bases/'+datos.base).once('value').then(snap3 =>{
                        let datos3 = snap3.val();
                        firebase.database().ref('Vehiculos/'+datos2.vehiculo).once('value').then(snap4 =>{
                                let datos4 = snap4.val();
                                datos.emple = datos2.nombre;
                                datos.base = datos3.Nombre;
                                datos.vehiculo = datos4.movil;
                                this.setState({viajes:[...this.state.viajes,datos]});
                        })
                    })
                })
            });
        })
    }

    getDisponible = () =>{
        firebase.database().ref('/LaboresEmpresa').orderByChild('cooncordancia').on('value', snap =>{
            this.setState({viajes:[]})
            snap.forEach(element => {
                let datos = element.val();
                if(datos.emple !== undefined){
                    firebase.database().ref('Empleados/'+datos.emple).once('value').then(snap2 =>{
                        let datos2 = snap2.val();
                        firebase.database().ref('Bases/'+datos.base).once('value').then(snap3 =>{
                            let datos3 = snap3.val();
                            firebase.database().ref('Vehiculos/'+datos2.vehiculo).once('value').then(snap4 =>{
                                    let datos4 = snap4.val();
                                    datos.emple = datos2.nombre;
                                    datos.base = datos3.Nombre;
                                    datos.vehiculo = datos4.movil;
                                    this.setState({viajes:[...this.state.viajes,datos]});
                            })
                        })
                    })
                }
            });
        })
    }

    render() {
        let { bases, tipoV, viajes} = this.state;
        return (
            <div className="container col-11 col-sm-11">
                <div className="form-row align-items-center">
                    <div className="col-sm-1 my-1">
                        <label className="text-gray">Filtros</label>
                    </div>
                    <div className="col-sm-3 my-1">
                        <select defaultValue={this.state.tipoS}  onChange={this.handleChangeT} className="form-control bg-select my-1 mr-sm-2">
                            <option value='indice'  disabled>Todos los vehículo</option>
                            {tipoV.map((snap, index) =>{
                                return(
                                    <option key={'tipod'+index} value={snap.tipo} >{snap.tipo}</option>
                                )
                            })}        
                        </select>
                    </div>
                    <div className="col-sm-3 my-1">
                        <select defaultValue={this.state.baseS} onChange={this.handleChangeB} className="form-control bg-select my-1 mr-sm-2">
                            <option value='indice'  disabled>Todas las bases</option>
                            {bases.map((snap, index) =>{
                                return(
                                    <option key={'basesd'+index} value={snap.key} >{snap.Nombre}</option>
                                )
                            })} 
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="table-responsive">
                        <table className="table text-center">
                            <thead>
                                <tr>
                                    <th scope="col">Orden</th>
                                    <th scope="col">Base</th>
                                    <th scope="col">Vehículo</th>
                                    <th scope="col">Unidad</th>
                                    <th scope="col">Capacidad</th>
                                    <th scope="col">Conductor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {viajes.map((snap, index) =>{
                                    return(
                                        <tr key={'conten'+index}>
                                            <th scope="row">{snap.cooncordancia}</th>
                                            <td>{snap.base}</td>
                                            <td>{snap.tipoV}</td>
                                            <td>{snap.vehiculo}</td>
                                            <td>4</td>
                                            <td>{snap.emple}</td> 
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}
export default Disponibilidad


// WEBPACK FOOTER //
// ./src/Components/Planificacion/disponibilidad.js